import script from "./VotingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./VotingWidget.vue?vue&type=script&setup=true&lang=js"

import "./VotingWidget.vue?vue&type=style&index=0&id=783b0966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783b0966"]])

export default __exports__